import config from "config";
import { ContentLayoutType3 } from "pages/Product/ContentLayouts/ContentLayoutType3";
import {
  AssetArea,
  DescriptionArea1,
  DescriptionArea2,
  DescriptionContent,
  DescriptionTitle,
  Image,
  SectionSubTitle,
  SectionTitle,
  TitleArea,
} from "pages/Product/ContentLayouts/styled";
import { FeatureSectionWrapper } from "pages/Product/FeaturesSection/styled";
import React from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

const StyledContentLayoutType3 = styled(ContentLayoutType3)`
  ${AssetArea} {
    padding: 0 0 20px 0;
  }

  ${mediaMin.xs`
    ${AssetArea} {
      padding: 60px 0;
    }
  `};

  ${mediaMin.md`
    ${AssetArea} {
      padding: 0;
    }
  `};
`;

export function Invoice() {
  return (
    <FeatureSectionWrapper id="invoice">
      <StyledContentLayoutType3>
        <TitleArea>
          <SectionSubTitle>How can I manage</SectionSubTitle>
          <SectionTitle>Invoice?</SectionTitle>
        </TitleArea>
        <DescriptionArea1>
          <DescriptionTitle>Smart Invoicing</DescriptionTitle>
          <DescriptionContent>
            The invoices will be automatically created by contract and sent on
            the issue date.
          </DescriptionContent>
        </DescriptionArea1>
        <DescriptionArea2>
          <DescriptionTitle>Payment Reminder</DescriptionTitle>
          <DescriptionContent>
            It is easy to check the payment status and the automatic reminder
            will be sent on your behalf.
          </DescriptionContent>
        </DescriptionArea2>
        <AssetArea>
          <Image
            src={`${config.RESOURCE_ORIGIN}/images/landing/product/feature-invoice.png`}
          />
        </AssetArea>
      </StyledContentLayoutType3>
    </FeatureSectionWrapper>
  );
}
